// src/pages/PromotionLetter.js
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import html2pdf from 'html2pdf.js';
import '../letterstyles/PromotionLetter.css';

const PromotionLetter = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const printRef = useRef();

  const user = state?.user;
  const superAdminId = Number(localStorage.getItem('adminuserId')) || 0;

  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  // Redirect if no user data
  useEffect(() => {
    if (!user) {
      alert("No employee data provided");
      navigate('/');
    }
  }, [user, navigate]);

  // Fetch company details
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        setLoading(true);
        const res = await fetch(`https://payyug.in/api/get-company?superAdminId=${superAdminId}`);
        const data = await res.json();
        if (res.ok && data) {
          if (data.logo) data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, '')}`;
          setCompany(data);
        } else {
          console.error("Failed to fetch company details");
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
      } finally {
        setLoading(false);
      }
    };
    if (superAdminId) fetchCompany();
  }, [superAdminId]);

  // Print handler
 const handlePrint = useReactToPrint({
     contentRef: printRef,
     documentTitle: 'Joining_Letter',
  });

  // PDF Download
  const handleDownload = () => {
    if (!printRef.current) return;

    const element = printRef.current;
    const opt = {
      // margin: [5,5,5,5],
      filename: `${user?.fullName || 'Employee'}_Promotion_Letter.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 3,
        useCORS: true,
        allowTaint: true,
        scrollY: 0,
        logging: false,
        dpi: 300,
        letterRendering: true,
      },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait',compressPdf:true },
    };

    html2pdf().set(opt).from(element).save();
  };

  if (!user) return null;
  if (loading) return <p>Loading company details...</p>;

  return (
    <div className="letter-wrapper">
      <div className="joining-letter" ref={printRef}>
        {/* Header */}
        <div className="letter-header">
          <img src={company?.logoUrl || '/default-logo.png'} alt="Company Logo" className="letter-logo" />
          <div className="letter-company-info"  style={{ textAlign: 'center' }}>
            <h2>{company?.name}</h2>
            <p><strong>CIN:</strong> {company?.cin || 'N/A'}</p>
            <p><strong>Regt. Office:</strong> {company?.address || 'N/A'}</p>
            <p><strong>Email:</strong> {company?.email || 'N/A'}</p>
            <p><strong>Contact:</strong> {company?.contact || 'N/A'}</p>
          </div>
          <img
            style={{ opacity: 0 }}
            src={company?.logoUrl || "/default-logo.png"}
            alt="Company Logo"
            className="letter-logo"
          />

        </div>

        {/* Promotion Letter */}
          <div
            style={{
              textAlign: "center",
              margin: "20px 0",
            }}
          >
            <h2
              style={{
                margin: 0,
                fontWeight: "600",
                fontSize: "20px",
                letterSpacing: "1px",
                textTransform: "uppercase",
              }}
            >
              Promotion Letter
            </h2>
          </div>

        {/* Body */}
        <div className="letter-body">
          <p className="letter-date"><strong>Date:</strong> {new Date().toLocaleDateString()}</p>

          <p>To,</p>
          <p><strong>{user.fullName}</strong></p>
          <p>{user.branchName || user.branch}</p>
          <p><strong>Employee ID:</strong> {user.userId}</p>

          <p><strong>Subject:</strong> Promotion & Professional Experience Confirmation</p>

          <p>Dear {user.fullName},</p>

          <p>
            We are delighted to formally acknowledge your professional growth and promotion at <strong>{company?.name}</strong>. 
            You have been an integral part of our team at the <strong>{user.branchName || user.branch}</strong> branch, serving as <strong>{user.roleName || user.role}</strong>.
          </p>

          <p>
            Your consistent dedication, exemplary performance, and professional conduct have been instrumental in the success of our organization. 
            Effective from <strong>{new Date().toLocaleDateString()}</strong>, you are hereby promoted to the role of <strong>{user.newRole || 'Senior ' + (user.roleName || user.role)}</strong>.
          </p>

          <p>
            We trust you will continue to uphold the standards of excellence and contribute meaningfully to the company’s vision and objectives.
          </p>

          <p className="letter-congrats"><strong>We congratulate you on this achievement and look forward to your continued success!</strong></p>

          <p>Sincerely,</p>
          <p className="letter-signer">
            HR Manager<br />
            {company?.name}
          </p>
        </div>

        {/* Footer */}
        <div className="letter-footer">
          <hr />
          <p>{company?.name} | CIN: {company?.cin}</p>
          <p>Email: {company?.email} | {company?.contact}</p>
        </div>
      </div>

       <div className="letter-actions">
          <button className="letter-action-button" onClick={handlePrint}>🖨️ Print</button>
          <button className="letter-action-button" onClick={handleDownload}>⬇️ Download</button>
        </div>
    </div>
  );
};

export default PromotionLetter;
